const localState = {
    error: {},
    show: false,
}
const mutations = {
    setError(state, data) {
        state.error = data
        state.show = true
    },
    clearError(state) {
        setTimeout(() => {
            state.error = {}
        }, 1000)
        state.show = false
    },
}
export default {
    state: localState,
    mutations,
}
